const getters = {

	// COMPONENT
		// vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  userInfo(state, getters){
    return JSON.parse(localStorage.getItem('userInfo'))
  },
  getActiveStore(state, getters){
    return JSON.parse(localStorage.getItem('active_store'))
  },
  getToken(state, getters) {
    return JSON.parse(localStorage.getItem('token'))
  },
  fcmProgress(state, getters) {
    return localStorage.getItem('fcm_progress')
  },
  isRenderingPersonID(state) {
    return state.person_id_rendering.ids.filter(
      val => val.status == 'pending'
    ).length > 0
  },
  isRenderingIDSuccessfull(state) {
    return state.person_id_rendering.ids.filter(
      val => val.status == 'success'
    ).length == state.person_id_rendering.ids.length
  }
}

export default getters